import { observer } from "mobx-react";
import React from "react";
import { Redirect, RouteComponentProps, withRouter } from "react-router-dom";
import { Switch as SwitchContext } from "react-router";
import AuthStore from "stores/AuthStore";

import Container from "components/Layout/Container";
import Header from "components/Layout/Header";
import { PrivateRoute } from "navigation/Switch";
import ROUTES from "navigation/routes";
import User from "./User";
import UserDetails from "./User/UserDetail/UserDetail";

type Props = RouteComponentProps & {};

@observer
class ProfileResources extends React.Component<Props> {
  render() {
    return (
      <Container header={<Header />}>
        <SwitchContext>
          <PrivateRoute
            path={ROUTES.CONTENT_PROFILE_USER}
            component={User}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_PROFILE_USER}
            exact
          />
          <PrivateRoute
            path={ROUTES.CONTENT_PROFILE_USER_DETAIL}
            component={UserDetails}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_PROFILE_USER_DETAIL}
            exact
          />

          <Redirect to={ROUTES.CONTENT_PROFILE_USER} />
        </SwitchContext>
      </Container>
    );
  }
}

export default withRouter(ProfileResources);
